import { UserAvatar } from "@/components/elements";
import { LANGUAGES, LanguageDataMap } from "@/constants/languages";
import { getLanguageFlag } from "@/utils/links";
import { AutoFixHighRounded } from "@mui/icons-material";
import {
  ListItem,
  ListItemAvatar,
  ListItemOwnProps,
  ListItemText,
  Typography
} from "@mui/material";
import React from "react";

interface LanguageCardProps {
  language: LANGUAGES;
  onClick: any;
  listItemProps?: ListItemOwnProps;
  rightChild?: React.ReactNode | undefined;
  minimal?: boolean;
}

export const LanguageCard = ({
  language,
  onClick,
  listItemProps,
  rightChild,
  minimal = false
}: LanguageCardProps): React.ReactNode => {
  const isAuto = language === LANGUAGES.AUTO;

  const iconSize = minimal ? 16 : 32;

  return (
    <ListItem
      id={`language-option-${language.replaceAll("_", "-")}`}
      aria-haspopup="listbox"
      onClick={onClick}
      sx={{
        p: 0
      }}
      {...listItemProps}
      aria-label={`${LanguageDataMap[language]?.name?.toLowerCase()}`}
    >
      <ListItemAvatar
        sx={{ height: iconSize, width: iconSize, minWidth: iconSize + 16 }}
      >
        {language === LANGUAGES.AUTO ? (
          <AutoFixHighRounded sx={{ height: iconSize, width: iconSize }} />
        ) : (
          <UserAvatar
            displayName={language}
            avatarUrl={getLanguageFlag({
              language: LanguageDataMap[language]?.flag ?? "globe.svg"
            })}
            alt=""
            sizes={iconSize.toString()}
            sx={{
              height: iconSize,
              width: iconSize
            }}
          />
        )}
      </ListItemAvatar>
      <ListItemText
        primary={
          <Typography
            variant={minimal ? "body2" : "h6"}
            textTransform={"capitalize"}
          >
            {isAuto ? "Auto-Detect" : LanguageDataMap[language]?.name}
          </Typography>
        }
        secondary={
          isAuto ? (
            ""
          ) : (
            <Typography
              variant={minimal ? "caption" : "body2"}
              color={"text.secondary"}
            >
              {minimal ? language : LanguageDataMap[language]?.name}
            </Typography>
          )
        }
        sx={{
          my: 0,
          ...(minimal
            ? {
                display: "flex",
                gap: (theme) => theme.spacing(1),
                alignItems: "center"
              }
            : {})
        }}
      />
      {rightChild}
    </ListItem>
  );
};
